import { FC } from 'react'
import { useMount } from 'ahooks'
import { To, useNavigate } from 'react-router-dom'
import { routePaths } from '../common/routing/routePaths'
import { apiClient } from '../api/ApiClient'
import { ChatLocationState } from './types/ChatLocationState'

export const ChatInit: FC = () => {
  const navigate = useNavigate()

  useMount(async () => {
    let to: To
    let state: ChatLocationState | undefined

    const purchasePayload = getPurchaseOrderPayload()

    if (purchasePayload) {
      to = {
        pathname: routePaths.purchaseOrder(purchasePayload.quoteId),
        search: `?redirectUrl=${purchasePayload.redirectUrl}`,
      }
    } else {
      const source = new URLSearchParams(window.location.search).get('source') ?? undefined
      const { id, isLocked } = await apiClient.chats.getActiveChat(source)

      to = routePaths.chat(id)
      state = { isChatLocked: isLocked ?? false }
    }

    navigate(to, { state })
  })

  return null
}

type PurchaseOrderPayload = {
  quoteId: string;
  redirectUrl: string;
}

function getPurchaseOrderPayload(): PurchaseOrderPayload | null {
  const searchParams = new URLSearchParams(window.location.search)
  const quoteId = searchParams.get('quoteId')
  const redirectUrl = searchParams.get('redirectUrl')

  return searchParams.get('action') === 'purchase-order' && quoteId && redirectUrl ? { quoteId, redirectUrl } : null
}
